import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import { BASIC_BUTTON_TYPE_OUTLINED } from '@divvy-web/skylab.basicbutton'

import { LogoutButton } from '@sputnik/components'
import GoToDashboardButton from '@sputnik/components/GoToDashboardButton'
import ImageWrapper from '@sputnik/components/ImageWrapper'

import styles from './styles.module.scss'

const NotFound = () => {
  const [getClassName] = useNameFormatter('NotFound')

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('main-content')]}>
        <ImageWrapper
          alt='binoculars'
          dataTestId='image-404'
          imageName='people_bird_watchers2'
        />
        <div
          className={styles[getClassName('message')]}
          data-testid='message-404'
        >
          <FormattedMessage
            defaultMessage="We couldn't find the page you were looking for."
            id='sputnik.NotFound__MtrRDG'
          />
        </div>
        <div className={styles[getClassName('buttons')]}>
          <LogoutButton buttonType={BASIC_BUTTON_TYPE_OUTLINED} />
          <GoToDashboardButton componentName={getClassName('')} />
        </div>
      </div>
    </div>
  )
}

export default NotFound
